import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IPermissionProps } from "../../models/Login";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { ITeamMast } from "../teamManagement/Table";
import { ISkillFilter } from "../teamManagement/Filter";
import { CompanyMapping } from "./CompanyMapping";
import { TeamMembers } from "./TeamMembers";
import { Toolbar } from "primereact/toolbar";

interface Iprops {
    permissions: IPermissionProps,
    toast: any,
    reload: boolean,
    setReload: (reload: boolean) => void,
    setModal: (data: { singleData: any, open: boolean }) => void,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [openMapping, setOpenMapping] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [openTeamMember, setOpenTeamMember] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [skillFilter, setSkillFilter] = useState<ISkillFilter>({});

    const header = () => {
        return <p>Allocate Team Mast</p>
    }

    const openEdit = (rowData: any) => {
        props.setModal({ open: true, singleData: rowData });
    }

    const action = (rowData: any) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
                <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => setOpenMapping({ open: true, singleData: rowData })}></Button>
                <Button className="pi pi pi-user text-primary bg-white border-none" onClick={() => setOpenTeamMember({ open: true, singleData: rowData })}></Button>
                {/* <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => props.setModal2({ open: true, singleData: rowData })}></Button> */}
                {/* {props.permissions.is_Delete && <Button className="pi pi-trash text-primary bg-white border-none" onClick={() => confirmDelete(rowData)}></Button>} */}
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Allocate_Team_Mast/getTeam", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(skillFilter)}`, props.toast);
        if (response) {
            const data: Array<ITeamMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const openNew = () => {
        props.setModal({
            open: true, singleData: {
                Team_Name: "",
                Company_Name: 0,
                Branch_Name: 0,
                TeamManagerid: 0
            }
        });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
        return (
            props.permissions.is_Create ?
                <React.Fragment>
                    <div className="my-2">
                        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    </div>
                </React.Fragment> : ''
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="team_Name" header="Team Name" />
                <Column field="company" header="Company" />
                <Column field="branch" header="Branch" />
                <Column field="team_Manager" header="Team Manager" />
                {props.permissions.is_Update && <Column field="" header="Action" body={action} />}
                <Column field="" header="Action" body={action} />
            </DataTable>
            <CompanyMapping open={openMapping.open} singleData={openMapping.singleData} hideDialog={() => setOpenMapping({ open: false, singleData: {} })} toast={props.toast} />
            <TeamMembers open={openTeamMember.open} singleData={openTeamMember.singleData} hideDialog={() => setOpenTeamMember({ open: false, singleData: {} })} toast={props.toast} />
        </>
    );
}